/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="rgba(38, 38, 38, 0.5)"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.24029 1.04297C3.21884 1.04297 2.70811 1.04297 2.27676 1.25271C1.81587 1.47681 1.38618 1.96129 1.21875 2.44565C1.06204 2.89897 1.11562 3.34423 1.22277 4.23476C1.51415 6.65643 2.1871 9.00308 3.4557 11.1523C4.71949 13.2934 6.44551 15.0587 8.55186 16.3657C10.7756 17.7456 13.2293 18.4706 15.7665 18.7772C16.6563 18.8847 17.1012 18.9385 17.5547 18.7819C18.0392 18.6147 18.5241 18.1848 18.7483 17.7239C18.9582 17.2925 18.9582 16.7819 18.9582 15.7609C18.9582 14.9311 18.9582 14.5163 18.8283 14.1659C18.6785 13.7616 18.4069 13.4138 18.051 13.1704C17.7426 12.9594 17.3401 12.8588 16.5352 12.6576L15.6567 12.4379C14.7528 12.212 14.3009 12.099 13.8545 12.1085C13.4591 12.117 13.0682 12.1957 12.7004 12.3411C12.2851 12.5052 11.9123 12.7844 11.1665 13.3428L10.358 13.9482C9.82255 14.3491 9.55483 14.5496 9.21899 14.6297C8.95226 14.6933 8.58403 14.6793 8.32294 14.5955C7.99419 14.49 7.78309 14.3051 7.36089 13.9355C6.84273 13.4819 6.35997 12.991 5.91466 12.4649C5.53959 12.0218 5.35206 11.8002 5.25312 11.4585C5.17462 11.1874 5.17406 10.8074 5.25176 10.5361C5.3497 10.1941 5.57244 9.92938 6.01793 9.39993L6.42972 8.91054C7.07225 8.14691 7.39351 7.76509 7.5857 7.33025C7.75589 6.94517 7.85159 6.53133 7.86773 6.11062C7.88597 5.63555 7.76494 5.15146 7.5229 4.18327L7.34356 3.46593C7.14233 2.66099 7.04171 2.25852 6.83076 1.95012C6.58734 1.59424 6.2395 1.32266 5.83522 1.17282C5.48486 1.04297 5.07 1.04297 4.24029 1.04297Z"/>
  </svg>
);

export default SvgComponent;
